import React, { useEffect, useRef, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { handleErrorToast } from '../../CustomFunctions';
import { useLocation } from 'react-router-dom';
import { DynamicBankDetailsChangeApprovalTable, DynamicImprestApprovalTable, DynamicInvestmentApprovalTable, DynamicsExpenseApproveTable, DynamicArrearApprovalTable, DynamicCompensatoryApprovalTable } from './DynamicApprovalTables';
import Dashboardnavbarcopy from '../../../layout/Dashboardnavbarcopy';


const DynamicRequestsManagementTab = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 1;
    const requesttoggle = location.state !== null ? location.state?.requesttoggle ? location.state?.requesttoggle : 9 : 9;
    const [toggleState, setToggleState] = useState(requesttoggle);
    const role = sessionStorage.getItem('role');

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return "Leave Request";
            case 2:
                return "Outduty Request";
            case 3:
                return 'CompOff Requests';
            case 4:
                return 'Imprest Requests';
            case 5:
                return 'Expenses Requests';
            case 6:
                return 'Advance Requests';
            case 7:
                return 'Separation Requests';
            case 8:
                return 'Employee Details Change Requests';
            case 9:
                return 'Bank Details Change Requests';
            case 12:
                return 'Arrear Requests';
            case 13:
                return 'Compensatory Leave Requests';
            default:
                return 'Dynamic Approval Request';
        }
    };

    return (
        <>
            {/* <Dashboardnavbarcopy name={getSelectedTitle()} url={`${role} Requests Management`} /> */}
            <Dashboardnavbarcopy name={getSelectedTitle()} url={`Dynamic Requests Management`} />
            <div className="content-tabs">
                {/* <TeamRequestManagment secondtoggle={secondtoggle} /> */}
                <>
                    <div>
                        <div className="bloc-tabs-with-white-bg">
                            {/* <button
                                className={
                                    toggleState === 1
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(1)}
                            >
                                Leave Request
                            </button>

                            <button
                                className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(2)}
                            >
                                Outduty Request
                            </button> */}
                            {/* <button
                                className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(3)}
                            >
                                CompOff Requests
                            </button> */}
                            {/* <button
                                className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(4)}
                            >
                                Imprest Requests
                            </button>
                            <button
                                className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(5)}
                            >
                                Expense Requests
                            </button> */}
                            {/* <button
                                className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(6)}
                            >
                                Advance Requests
                            </button> */}
                            {/* <button
                                className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(7)}
                            >
                                Separation Requests
                            </button> */}
                            {/* <button
                                className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(8)}
                            >
                                Employee Details Change Requests
                            </button> */}
                            <button
                                className={toggleState === 9 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(9)}
                            >
                                Bank Details Change Requests
                            </button>

                            <button
                                className={toggleState === 10 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(10)}
                            >
                                Investment Declaration Approvals
                            </button>

                            <button
                                className={toggleState === 11 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(11)}
                            >
                                Investment Proof Approvals
                            </button>
                            <button
                                className={toggleState === 12 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(12)}
                            >
                                Arrear Requests
                            </button>
                            <button
                                className={toggleState === 13 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(13)}
                            >
                                Compensatory Requests
                            </button>


                        </div>

                        <div className="content-tabs-without-margin">
                            {/* {toggleState === 1 ? <DynamicLeaveApprovalStages /> : null}
                            {toggleState === 2 ? <DynamicOutdutyApprovalStages /> : null}
                            {toggleState === 3 ? <DynamicCompOffApprovalStages /> : null} */}
                            {toggleState === 4 ? <DynamicImprestApprovalStages /> : null}
                            {toggleState === 5 ? <DynamicExpenseBillingApprovalStages /> : null}
                            {/* {toggleState === 6 ? <DynamicAdvanceApprovalStages /> : null}
                            {toggleState === 7 ? <DynamicSeprationApprovalStages /> : null}
                            {toggleState === 8 ? <DynamicEmpDetailsChangeApprovalStages /> : null} */}
                            {toggleState === 9 ? <DynamicBankDetailsChangeApprovalStages /> : null}
                            {toggleState === 10 ? <DynamicInvestmentApprovalStages approvalType="investment_declaration" /> : null}
                            {toggleState === 11 ? <DynamicInvestmentApprovalStages approvalType="investment_proof" /> : null}
                            {toggleState === 12 ? <DynamicArrearApprovalStages /> : null}
                            {toggleState === 13 ? <DynamicApprovalAllFormatStages approvalType="compensatory" /> : null}

                        </div>
                    </div>
                </>
            </div >
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};


const DynamicLeaveApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const imprestStage = location.state !== null ? location.state?.imprestStage ? location.state?.imprestStage : 0 : 0;
    const [toggleState, setToggleState] = useState(imprestStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getImprestApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Imprest/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getImprestApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(imprestStage === 0 ? matchedStages[0].level : imprestStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Leave {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicImprestApprovalTable level={toggleState} />
                    }
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};

const DynamicOutdutyApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const imprestStage = location.state !== null ? location.state?.imprestStage ? location.state?.imprestStage : 0 : 0;
    const [toggleState, setToggleState] = useState(imprestStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getImprestApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Imprest/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getImprestApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(imprestStage === 0 ? matchedStages[0].level : imprestStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Out Duty {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicImprestApprovalTable level={toggleState} />
                    }
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};

const DynamicCompOffApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const tenderStage = location.state !== null ? location.state?.tenderStage ? location.state?.tenderStage : 0 : 0;
    const [toggleState, setToggleState] = useState(tenderStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getTenderApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Tender/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getTenderApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(tenderStage === 0 ? matchedStages[0].level : tenderStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Compensatory Off {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {/* {filteredStages?.length > 0
                        &&
                        <DynamicTenderApprovalTable level={toggleState} />
                    } */}
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};

const DynamicImprestApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const imprestStage = location.state !== null ? location.state?.imprestStage ? location.state?.imprestStage : 0 : 0;
    const [toggleState, setToggleState] = useState(imprestStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getImprestApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Imprest/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getImprestApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(imprestStage === 0 ? matchedStages[0].level : imprestStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Imprest {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicImprestApprovalTable level={toggleState} />
                    }
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};

const DynamicExpenseBillingApprovalStages = () => {

    const location = useLocation();
    // const firsttoggle = location.state !== null ? location.state?.firsttoggle ? location.state?.firsttoggle : 1 : 1;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    // const requesttoggle = location.state !== null ? location.state?.requesttoggle ? location.state?.requesttoggle : 1 : 1;
    const expenseStage = location.state !== null ? location.state?.expenseStage ? location.state?.expenseStage : 0 : 0;
    const [toggleState, setToggleState] = useState(expenseStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    // console.log("expenseStage-", expenseStage)
    // console.log("toggleState")
    // console.log(toggleState)

    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getImprestApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Expense/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getImprestApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(expenseStage === 0 ? matchedStages[0].level : expenseStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Expense {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {filteredStages?.length > 0
                        &&
                        <DynamicsExpenseApproveTable level={toggleState} />
                    }
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};

const DynamicAdvanceApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const tenderStage = location.state !== null ? location.state?.tenderStage ? location.state?.tenderStage : 0 : 0;
    const [toggleState, setToggleState] = useState(tenderStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getTenderApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Tender/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getTenderApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(tenderStage === 0 ? matchedStages[0].level : tenderStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Advance {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {/* {filteredStages?.length > 0
                        &&
                        <DynamicTenderApprovalTable level={toggleState} />
                    } */}
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};

const DynamicSeprationApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const tenderStage = location.state !== null ? location.state?.tenderStage ? location.state?.tenderStage : 0 : 0;
    const [toggleState, setToggleState] = useState(tenderStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getTenderApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Tender/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getTenderApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(tenderStage === 0 ? matchedStages[0].level : tenderStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Sepration {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {/* {filteredStages?.length > 0
                        &&
                        <DynamicTenderApprovalTable level={toggleState} />
                    } */}
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};

const DynamicEmpDetailsChangeApprovalStages = () => {

    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 3;
    // const secondtoggle = location.state !== null ? location.state?.secondtoggle : 0;
    // const secondtoggle = 0;
    const tenderStage = location.state !== null ? location.state?.tenderStage ? location.state?.tenderStage : 0 : 0;
    const [toggleState, setToggleState] = useState(tenderStage);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const toggle_company = sessionStorage.getItem('company_id')

    console.log("toggleState")
    console.log(toggleState)
    const [dynamicApprovalStages, setDynamicApprovalStages] = useState([]);
    const [buffer, setBuffering] = useState(false); //buffering logic
    const getTenderApprovalStages = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const pro = await axios.get(`${BASE_URL}/siteproject/dynamicapprovalformatstages-bysubcompany-bytype/${toggle_company}/Tender/`);
            setDynamicApprovalStages(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getTenderApprovalStages();
    }, []);


    useEffect(() => {
        if (dynamicApprovalStages?.approval_stages?.length > 0) {
            const matchedStages = dynamicApprovalStages.approval_stages.filter(stage =>
                (stage.role_name && stage.role_name === role) ||
                (stage.employee && stage.employee === employee)
            );

            if (matchedStages.length > 0) {
                setToggleState(tenderStage === 0 ? matchedStages[0].level : tenderStage);
            } else {
                setToggleState(0);
            }
        }
    }, [dynamicApprovalStages, role, employee]);

    const filteredStages = dynamicApprovalStages?.approval_stages
        ?.filter(stage =>
            (stage.role_name && stage.role_name === role) ||
            (stage.employee && stage.employee === employee)
        );

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        filteredStages?.length > 0
                            ?
                            <div className="bloc-tabs-with-white-bg">
                                {
                                    filteredStages?.map((stages, index) => {
                                        return (
                                            <button
                                                style={{
                                                    cursor: 'help'
                                                }}
                                                className={
                                                    toggleState === stages.level
                                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                                }
                                                title={`Stage for ${stages.permissions}`}
                                                // title={`${stages.permissions === 'Approve-Reject-Edit' ? '' : ''}`}
                                                onClick={() => setToggleState(stages.level)}
                                            >
                                                Employee details {stages.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stages.level}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                            :
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                }

                <div className="content-tabs-without-margin">

                    {/* {filteredStages?.length > 0
                        &&
                        <DynamicTenderApprovalTable level={toggleState} />
                    } */}
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>

    );
};


const DynamicBankDetailsChangeApprovalStages = () => {
    const location = useLocation();
    const bankDetailStage = location.state !== null ? location.state?.bankDetailStage ? location.state?.bankDetailStage : 0 : null;
    const bankDetailVersion = location.state !== null ? location.state?.bankDetailVersion ? location.state?.bankDetailVersion : 0 : null;

    const [selectedLevel, setSelectedLevel] = useState(bankDetailStage || 0);
    const [selectedVersion, setSelectedVersion] = useState(bankDetailVersion || 1);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const isreportinghead = sessionStorage.getItem('is_rh')
    const toggle_company = sessionStorage.getItem('company_id')

    const [dynamicApprovalFormats, setDynamicApprovalFormats] = useState([]);
    const [pendingInVersion, setPendingInVersion] = useState(0);
    const [buffer, setBuffering] = useState(false);

    // Add useState for derived values
    const [allVersions, setAllVersions] = useState([]);
    const [accessibleStages, setAccessibleStages] = useState([]);
    const [hasAnyAccess, setHasAnyAccess] = useState(false);
    const [formatFor, setformatFor] = useState('bankdetails')
    const getDynamicApprovalStages = async () => {
        setBuffering(true);
        try {
            // const pro = await axios.get(`${BASE_URL}/wfm/dynamicapproval-versionedformatstages-bysubcompany-bytype-withpendingcount/${toggle_company}/bankdetails/${employee}/`);
            const pro = await axios.get(`${BASE_URL}/wfm/dynamicapproval-versionedformatstages-bysubcompany-bytype-withpendingcount/${toggle_company}/${formatFor}/${employee}/`);
            const data = pro.data;
            setDynamicApprovalFormats(data);
            const totalPendingSum = data.reduce((sum, format) => {
                return sum + (format.total_pending_requests_count || 0);
            }, 0);

            setPendingInVersion(totalPendingSum);

            const currentActiveFlowFormat = data.find(format => format.is_active === true);

            if (selectedVersion === 1 && data.length > 0) {
                if (currentActiveFlowFormat) {
                    setSelectedVersion(currentActiveFlowFormat.version);

                    const accessibleStages = currentActiveFlowFormat.approval_stages?.filter(stage =>
                        (stage.role && stage.role === role) ||
                        (stage.employee && stage.employee === employee) ||
                        (stage.role === "ReportingHead" && isreportinghead)
                    ) || [];

                    if (accessibleStages.length > 0) {
                        const firstAccessibleStage = accessibleStages.sort((a, b) => a.level - b.level)[0];
                        setSelectedLevel(firstAccessibleStage.level);
                    }
                }
            }

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getDynamicApprovalStages();
    }, []);

    const getAllVersions = () => {
        return dynamicApprovalFormats.map(format => ({
            version: format.version,
            is_active: format.is_active,
            format_id: format.format_id,
            // approval_stages: format.approval_stages
        })).sort((a, b) => b.version - a.version); //Highest to lowest
    };

    // List of Accessible stages accross all versions
    const getFilteredStages = () => {
        if (!dynamicApprovalFormats.length) return [];

        let targetFormats = [];

        if (selectedVersion === 'all') {
            targetFormats = dynamicApprovalFormats;
        } else {
            const specificFormat = dynamicApprovalFormats.find(format => format.version === parseInt(selectedVersion));
            if (specificFormat) {
                targetFormats = [specificFormat];
            }
        }

        let accessibleStages = [];
        targetFormats.forEach(format => {
            const stagesForThisFormat = format.approval_stages?.filter(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            ) || [];

            const stagesWithFormatInfo = stagesForThisFormat.map(stage => ({
                ...stage,
                version: format.version,
                is_active: format.is_active,
                // approval_stages: format.approval_stages
            }));
            accessibleStages = [...accessibleStages, ...stagesWithFormatInfo];
        });

        return accessibleStages.sort((a, b) => a.level - b.level);
    };

    // True if has access to atleast 1 stage out of all versions
    const hasAccessToAnyVersion = () => {
        return dynamicApprovalFormats.some(format =>
            format.approval_stages?.some(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            )
        );
    };

    // Update derived states whenever dependencies change
    useEffect(() => {
        const newAllVersions = getAllVersions();
        const newAccessibleStages = getFilteredStages();
        const newHasAnyAccess = hasAccessToAnyVersion();

        setAllVersions(newAllVersions);
        setAccessibleStages(newAccessibleStages);
        setHasAnyAccess(newHasAnyAccess);
    }, [dynamicApprovalFormats, selectedVersion, role, employee, isreportinghead]);

    //  auto-selection 
    useEffect(() => {
        if (accessibleStages.length > 0 && selectedLevel === 0) {
            // Select the first stage from the current version
            const firstStage = accessibleStages[0];
            setSelectedLevel(firstStage.level);
        }
    }, [accessibleStages, selectedVersion]);

    // useEffect to handle version changes properly
    useEffect(() => {
        // This runs AFTER accessibleStages has been updated
        if (selectedVersion !== 'all') {
            // Find first stage in the selected version
            const thisVersionStages = accessibleStages.filter(stage =>
                stage.version === parseInt(selectedVersion)
            );

            if (thisVersionStages.length > 0) {
                const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                if (!stageExists) {
                    setSelectedLevel(thisVersionStages[0].level);
                }
            }
        }
    }, [selectedVersion, accessibleStages]);

    // Check if current selectedLevel is valid for selected version
    const isSelectedLevelValid = () => {
        if (selectedVersion === 'all') {
            return accessibleStages.some(stage => stage.level === selectedLevel);
        } else {
            return accessibleStages.some(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    // Get current active stage data for table
    const getStageDataForTable = () => {
        if (selectedVersion === 'all') {
            // When viewing all versions, find the stage that matches selectedLevel
            return accessibleStages.find(stage => stage.level === selectedLevel);
        } else {
            // When viewing specific version, find exact match
            return accessibleStages.find(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    const stageDataForTable = getStageDataForTable();
    const shouldShowTable = accessibleStages.length > 0 && isSelectedLevelValid();

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        hasAnyAccess ? (
                            <div className="bloc-tabs-with-white-bg justify-between">
                                {accessibleStages.length > 0 ? (
                                    <div className=" field-cont-div">
                                        {accessibleStages.map((stage, index) => {

                                            const isActiveTab =
                                                // selectedVersion === 'all'
                                                //     ? selectedLevel === stage.level
                                                //     :
                                                selectedLevel === stage.level && parseInt(selectedVersion) === stage.version;

                                            return (
                                                <button
                                                    key={`${stage.version}-${stage.level}-${index}`}
                                                    style={{
                                                        cursor: 'help',
                                                        position: 'relative'
                                                    }}
                                                    className={
                                                        `bloc-tabs-with-white-bg-div
                                                         ${isActiveTab
                                                            ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                            : "dashboardcomponent-tabs font-weight400 font-size-subheading white-tab"}`
                                                    }
                                                    title={`Stage for ${stage.permissions}  (Version ${stage.version} ${!stage.is_active ? '(Old Flow)' : ''})`}
                                                    onClick={() => {
                                                        setSelectedLevel(stage.level);
                                                        // when viewing all versions and clicking a stage from different version, auto-switch to that version
                                                        // if (selectedVersion === 'all' && stage.version !== parseInt(selectedVersion)) {
                                                        if (selectedVersion === 'all') {
                                                            setSelectedVersion(stage.version.toString());
                                                        }
                                                    }}
                                                >
                                                    Bank Details {stage.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stage.level}
                                                    {stage.pending_requests_count > 0 && (
                                                        <span
                                                            style={{
                                                                position: 'absolute',
                                                                top: '0px',
                                                                right: '-5px',
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                width: '13px',
                                                                height: '13px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                // border: '2px solid white',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                            }}
                                                            title={`${stage.pending_requests_count} pending requests`}
                                                        >
                                                            {stage.pending_requests_count > 99 ? '99+' : stage.pending_requests_count}
                                                        </span>
                                                    )}
                                                    <br />
                                                    <small className="text-gray-600">
                                                        {stage.employee
                                                            ? `Employee: ${stage.employee_name || stage.employee}`
                                                            : stage.role === "ReportingHead"
                                                                ? `Role: Reporting Head`
                                                                : stage.role
                                                                    ? `Role: ${stage.role}`
                                                                    : "Role/Dept not assigned"}
                                                        {selectedVersion === 'all' && ` • v${stage.version}`}
                                                        {!stage.is_active ? ' (Old)' : ' (Current)'}
                                                        {/* {stage.pending_requests_count > 0 && ` • ${stage.pending_requests_count} pending`} */}

                                                    </small>
                                                </button>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="bloc-tabs-with-white-bg justify-center">
                                        No accessible stages found for selected version
                                    </div>
                                )}

                                <div className="btn-cont">
                                    <hr className="field-cont-hr" />
                                    <div style={{ position: 'relative', display: 'inline-block' }}>

                                        <select
                                            className="attendance-input-field width-20vw date-field"
                                            value={selectedVersion}
                                            onChange={(e) => {
                                                const newVersion = e.target.value;
                                                console.log('newVersion ', newVersion)
                                                setSelectedVersion(newVersion);
                                                console.log('accessibleStages', accessibleStages)
                                                // selection when version changes
                                                if (newVersion === 'all') {
                                                    // Keep current stage if it exists in any version
                                                    const stageExists = accessibleStages.some(stage => stage.level === selectedLevel);
                                                    if (!stageExists && accessibleStages.length > 0) {
                                                        setSelectedLevel(accessibleStages[0].level);
                                                    }
                                                } else {
                                                    // Find first stage in the selected version
                                                    const thisVersionStages = accessibleStages.filter(stage =>
                                                        stage.version === parseInt(newVersion)
                                                    );

                                                    console.log('thisVersionStages', thisVersionStages)
                                                    if (thisVersionStages.length > 0) {
                                                        const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                                                        if (!stageExists) {
                                                            setSelectedLevel(thisVersionStages[0].level);
                                                        }
                                                    }
                                                }
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option value="all">All Versions</option>
                                            {allVersions.map(version => {
                                                const format = dynamicApprovalFormats.find(f => f.version === version.version);

                                                const totalPending = format?.total_pending_requests_count || 0;
                                                return (
                                                    <option key={version.version} value={version.version}>
                                                        Version {version.version} {version.is_active ? '(Current)' : '(Old)'}
                                                        {totalPending > 0 && (
                                                            <span style={{
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                padding: '2px 6px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                marginLeft: '8px'
                                                            }}>
                                                                {totalPending > 99 ? '[99+ pending]' : `[${totalPending} pending]`}
                                                            </span>
                                                        )}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                        {pendingInVersion > 0 && (
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    right: '-5px',
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: '13px',
                                                    height: '13px',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    // border: '2px solid white',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                }}
                                                title={`${pendingInVersion} pending requests`}
                                            >
                                                {pendingInVersion > 99 ? '99+' : pendingInVersion}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For This Request Management
                            </div>
                        )
                }

                <div className="content-tabs-without-margin">
                    {/* <div>
                        V{selectedVersion} - Stage {selectedLevel}
                    </div>
                    <br /> */}
                    {/*Only show table when we have a valid active stage */}
                    {shouldShowTable && stageDataForTable && (
                        <DynamicBankDetailsChangeApprovalTable
                            level={selectedLevel}
                            version={selectedVersion === 'all' ? stageDataForTable.version : parseInt(selectedVersion)}
                            formatData={dynamicApprovalFormats}
                            getApprovalStages={getDynamicApprovalStages}
                            formatFor={formatFor}
                        />
                    )}
                </div>
            </div >
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};


const DynamicInvestmentApprovalStages = ({ approvalType }) => {
    const location = useLocation();


    const investmentStage = location.state?.investmentStage || 0;
    const investmentVersion = location.state?.investmentVersion || 1;

    const [selectedLevel, setSelectedLevel] = useState(investmentStage);
    const [selectedVersion, setSelectedVersion] = useState(investmentVersion);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const isreportinghead = sessionStorage.getItem('is_rh')
    const toggle_company = sessionStorage.getItem('company_id')

    const [dynamicApprovalFormats, setDynamicApprovalFormats] = useState([]);
    const [pendingInVersion, setPendingInVersion] = useState(0);
    const [buffer, setBuffering] = useState(false);

    const [allVersions, setAllVersions] = useState([]);
    const [accessibleStages, setAccessibleStages] = useState([]);
    const [hasAnyAccess, setHasAnyAccess] = useState(false);
    const [formatFor, setFormatFor] = useState(approvalType);

    const getInvestmentApprovalStages = async () => {
        setBuffering(true);
        try {
            const pro = await axios.get(
                `${BASE_URL}/wfm/dynamicapproval-versionedformatstages-bysubcompany-bytype-withpendingcount/${toggle_company}/${formatFor}/${employee}/`
            );
            const data = pro.data;
            setDynamicApprovalFormats(data);

            const totalPendingSum = data.reduce((sum, format) => {
                return sum + (format.total_pending_requests_count || 0);
            }, 0);

            setPendingInVersion(totalPendingSum);

            const currentActiveFlowFormat = data.find(format => format.is_active === true);

            if (selectedVersion === 1 && data.length > 0) {
                if (currentActiveFlowFormat) {
                    setSelectedVersion(currentActiveFlowFormat.version);

                    const accessibleStages = currentActiveFlowFormat.approval_stages?.filter(stage =>
                        (stage.role && stage.role === role) ||
                        (stage.employee && stage.employee === employee) ||
                        (stage.role === "ReportingHead" && isreportinghead)
                    ) || [];

                    if (accessibleStages.length > 0) {
                        const firstAccessibleStage = accessibleStages.sort((a, b) => a.level - b.level)[0];
                        setSelectedLevel(firstAccessibleStage.level);
                    }
                }
            }

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getInvestmentApprovalStages();
    }, [approvalType]);

    const getAllVersions = () => {
        return dynamicApprovalFormats.map(format => ({
            version: format.version,
            is_active: format.is_active,
            format_id: format.format_id,
        })).sort((a, b) => b.version - a.version);
    };

    const getFilteredStages = () => {
        if (!dynamicApprovalFormats.length) return [];

        let targetFormats = [];

        if (selectedVersion === 'all') {
            targetFormats = dynamicApprovalFormats;
        } else {
            const specificFormat = dynamicApprovalFormats.find(format => format.version === parseInt(selectedVersion));
            if (specificFormat) {
                targetFormats = [specificFormat];
            }
        }

        let accessibleStages = [];
        targetFormats.forEach(format => {
            const stagesForThisFormat = format.approval_stages?.filter(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            ) || [];

            const stagesWithFormatInfo = stagesForThisFormat.map(stage => ({
                ...stage,
                version: format.version,
                is_active: format.is_active,
            }));
            accessibleStages = [...accessibleStages, ...stagesWithFormatInfo];
        });

        return accessibleStages.sort((a, b) => a.level - b.level);
    };

    const hasAccessToAnyVersion = () => {
        return dynamicApprovalFormats.some(format =>
            format.approval_stages?.some(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            )
        );
    };

    useEffect(() => {
        const newAllVersions = getAllVersions();
        const newAccessibleStages = getFilteredStages();
        const newHasAnyAccess = hasAccessToAnyVersion();

        setAllVersions(newAllVersions);
        setAccessibleStages(newAccessibleStages);
        setHasAnyAccess(newHasAnyAccess);
    }, [dynamicApprovalFormats, selectedVersion, role, employee, isreportinghead]);

    useEffect(() => {
        if (accessibleStages.length > 0 && selectedLevel === 0) {
            const firstStage = accessibleStages[0];
            setSelectedLevel(firstStage.level);
        }
    }, [accessibleStages, selectedVersion]);

    useEffect(() => {
        if (selectedVersion !== 'all') {
            const thisVersionStages = accessibleStages.filter(stage =>
                stage.version === parseInt(selectedVersion)
            );

            if (thisVersionStages.length > 0) {
                const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                if (!stageExists) {
                    setSelectedLevel(thisVersionStages[0].level);
                }
            }
        }
    }, [selectedVersion, accessibleStages]);

    const isSelectedLevelValid = () => {
        if (selectedVersion === 'all') {
            return accessibleStages.some(stage => stage.level === selectedLevel);
        } else {
            return accessibleStages.some(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    const getStageDataForTable = () => {
        if (selectedVersion === 'all') {
            return accessibleStages.find(stage => stage.level === selectedLevel);
        } else {
            return accessibleStages.find(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    const stageDataForTable = getStageDataForTable();
    const shouldShowTable = accessibleStages.length > 0 && isSelectedLevelValid();

    const getApprovalTypeDisplay = () => {
        return approvalType === 'investment_declaration' ? 'Investment Declaration' : 'Investment Proof';
    };

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        hasAnyAccess ? (
                            <div className="bloc-tabs-with-white-bg justify-between">
                                {accessibleStages.length > 0 ? (
                                    <div className="field-cont-div">
                                        {accessibleStages.map((stage, index) => {
                                            const isActiveTab = selectedLevel === stage.level && parseInt(selectedVersion) === stage.version;

                                            return (
                                                <button
                                                    key={`${stage.version}-${stage.level}-${index}`}
                                                    style={{
                                                        cursor: 'help',
                                                        position: 'relative',
                                                        // borderLeft: `4px solid ${getApprovalTypeColor()}`
                                                    }}
                                                    className={
                                                        `bloc-tabs-with-white-bg-div
                                                         ${isActiveTab
                                                            ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                            : "dashboardcomponent-tabs font-weight400 font-size-subheading white-tab"}`
                                                    }
                                                    title={`${getApprovalTypeDisplay()} - Stage for ${stage.permissions} (Version ${stage.version} ${!stage.is_active ? '(Old Flow)' : ''})`}
                                                    onClick={() => {
                                                        setSelectedLevel(stage.level);
                                                        if (selectedVersion === 'all') {
                                                            setSelectedVersion(stage.version.toString());
                                                        }
                                                    }}
                                                >
                                                    {getApprovalTypeDisplay()} {stage.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stage.level}
                                                    {stage.pending_requests_count > 0 && (
                                                        <span
                                                            style={{
                                                                position: 'absolute',
                                                                top: '0px',
                                                                right: '-5px',
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                width: '13px',
                                                                height: '13px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                            }}
                                                            title={`${stage.pending_requests_count} pending requests`}
                                                        >
                                                            {stage.pending_requests_count > 99 ? '99+' : stage.pending_requests_count}
                                                        </span>
                                                    )}
                                                    <br />
                                                    <small className="text-gray-600">
                                                        {stage.employee
                                                            ? `Employee: ${stage.employee_name || stage.employee}`
                                                            : stage.role === "ReportingHead"
                                                                ? `Role: Reporting Head`
                                                                : stage.role
                                                                    ? `Role: ${stage.role}`
                                                                    : "Role/Dept not assigned"}
                                                        {selectedVersion === 'all' && ` • v${stage.version}`}
                                                        {!stage.is_active ? ' (Old)' : ' (Current)'}
                                                    </small>
                                                </button>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="bloc-tabs-with-white-bg justify-center">
                                        No accessible stages found for selected version
                                    </div>
                                )}

                                <div className="btn-cont">
                                    <hr className="field-cont-hr" />
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <select
                                            className="attendance-input-field width-20vw date-field"
                                            value={selectedVersion}
                                            onChange={(e) => {
                                                const newVersion = e.target.value;
                                                setSelectedVersion(newVersion);

                                                if (newVersion === 'all') {
                                                    const stageExists = accessibleStages.some(stage => stage.level === selectedLevel);
                                                    if (!stageExists && accessibleStages.length > 0) {
                                                        setSelectedLevel(accessibleStages[0].level);
                                                    }
                                                } else {
                                                    const thisVersionStages = accessibleStages.filter(stage =>
                                                        stage.version === parseInt(newVersion)
                                                    );

                                                    if (thisVersionStages.length > 0) {
                                                        const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                                                        if (!stageExists) {
                                                            setSelectedLevel(thisVersionStages[0].level);
                                                        }
                                                    }
                                                }
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option value="all">All Versions</option>
                                            {allVersions.map(version => {
                                                const format = dynamicApprovalFormats.find(f => f.version === version.version);
                                                const totalPending = format?.total_pending_requests_count || 0;
                                                return (
                                                    <option key={version.version} value={version.version}>
                                                        Version {version.version} {version.is_active ? '(Current)' : '(Old)'}
                                                        {totalPending > 0 && (
                                                            <span style={{
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                padding: '2px 6px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                marginLeft: '8px'
                                                            }}>
                                                                {totalPending > 99 ? '[99+ pending]' : `[${totalPending} pending]`}
                                                            </span>
                                                        )}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                        {pendingInVersion > 0 && (
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    right: '-5px',
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: '13px',
                                                    height: '13px',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                }}
                                                title={`${pendingInVersion} pending requests`}
                                            >
                                                {pendingInVersion > 99 ? '99+' : pendingInVersion}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For {getApprovalTypeDisplay()} Request Management
                            </div>
                        )
                }

                <div className="content-tabs-without-margin">
                    {shouldShowTable && stageDataForTable && (
                        <DynamicInvestmentApprovalTable
                            level={selectedLevel}
                            version={selectedVersion === 'all' ? stageDataForTable.version : parseInt(selectedVersion)}
                            formatData={dynamicApprovalFormats}
                            getApprovalStages={getInvestmentApprovalStages}
                            formatFor={formatFor}
                        />
                    )}
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const DynamicArrearApprovalStages = ({ approvalType = 'arrear' }) => {
    const location = useLocation();

    const investmentStage = location.state?.investmentStage || 0;
    const investmentVersion = location.state?.investmentVersion || 1;

    const [selectedLevel, setSelectedLevel] = useState(0);
    const [selectedVersion, setSelectedVersion] = useState(1);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const isreportinghead = sessionStorage.getItem('is_rh')
    const toggle_company = sessionStorage.getItem('company_id')

    const [dynamicApprovalFormats, setDynamicApprovalFormats] = useState([]);
    const [pendingInVersion, setPendingInVersion] = useState(0);
    const [buffer, setBuffering] = useState(false);

    const [allVersions, setAllVersions] = useState([]);
    const [accessibleStages, setAccessibleStages] = useState([]);
    const [hasAnyAccess, setHasAnyAccess] = useState(false);
    const [formatFor, setFormatFor] = useState(approvalType);

    const getArrearApprovalStages = async () => {
        setBuffering(true);
        try {
            const pro = await axios.get(
                `${BASE_URL}/wfm/dynamicapproval-versionedformatstages-bysubcompany-bytype-withpendingcount/${toggle_company}/${formatFor}/${employee}/`
            );
            const data = pro.data;
            setDynamicApprovalFormats(data);

            const totalPendingSum = data.reduce((sum, format) => {
                return sum + (format.total_pending_requests_count || 0);
            }, 0);

            setPendingInVersion(totalPendingSum);

            const currentActiveFlowFormat = data.find(format => format.is_active === true);

            if (selectedVersion === 1 && data.length > 0) {
                if (currentActiveFlowFormat) {
                    setSelectedVersion(currentActiveFlowFormat.version);

                    const accessibleStages = currentActiveFlowFormat.approval_stages?.filter(stage =>
                        (stage.role && stage.role === role) ||
                        (stage.employee && stage.employee === employee) ||
                        (stage.role === "ReportingHead" && isreportinghead)
                    ) || [];

                    if (accessibleStages.length > 0) {
                        const firstAccessibleStage = accessibleStages.sort((a, b) => a.level - b.level)[0];
                        setSelectedLevel(firstAccessibleStage.level);
                    }
                }
            }

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getArrearApprovalStages();
    }, [approvalType]);

    const getAllVersions = () => {
        return dynamicApprovalFormats.map(format => ({
            version: format.version,
            is_active: format.is_active,
            format_id: format.format_id,
        })).sort((a, b) => b.version - a.version);
    };

    const getFilteredStages = () => {
        if (!dynamicApprovalFormats.length) return [];

        let targetFormats = [];

        if (selectedVersion === 'all') {
            targetFormats = dynamicApprovalFormats;
        } else {
            const specificFormat = dynamicApprovalFormats.find(format => format.version === parseInt(selectedVersion));
            if (specificFormat) {
                targetFormats = [specificFormat];
            }
        }

        let accessibleStages = [];
        targetFormats.forEach(format => {
            const stagesForThisFormat = format.approval_stages?.filter(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            ) || [];

            const stagesWithFormatInfo = stagesForThisFormat.map(stage => ({
                ...stage,
                version: format.version,
                is_active: format.is_active,
            }));
            accessibleStages = [...accessibleStages, ...stagesWithFormatInfo];
        });

        return accessibleStages.sort((a, b) => a.level - b.level);
    };

    const hasAccessToAnyVersion = () => {
        return dynamicApprovalFormats.some(format =>
            format.approval_stages?.some(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            )
        );
    };

    useEffect(() => {
        const newAllVersions = getAllVersions();
        const newAccessibleStages = getFilteredStages();
        const newHasAnyAccess = hasAccessToAnyVersion();

        setAllVersions(newAllVersions);
        setAccessibleStages(newAccessibleStages);
        setHasAnyAccess(newHasAnyAccess);
    }, [dynamicApprovalFormats, selectedVersion, role, employee, isreportinghead]);

    useEffect(() => {
        if (accessibleStages.length > 0 && selectedLevel === 0) {
            const firstStage = accessibleStages[0];
            setSelectedLevel(firstStage.level);
        }
    }, [accessibleStages, selectedVersion]);

    useEffect(() => {
        if (selectedVersion !== 'all') {
            const thisVersionStages = accessibleStages.filter(stage =>
                stage.version === parseInt(selectedVersion)
            );

            if (thisVersionStages.length > 0) {
                const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                if (!stageExists) {
                    setSelectedLevel(thisVersionStages[0].level);
                }
            }
        }
    }, [selectedVersion, accessibleStages]);

    const isSelectedLevelValid = () => {
        if (selectedVersion === 'all') {
            return accessibleStages.some(stage => stage.level === selectedLevel);
        } else {
            return accessibleStages.some(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    const getStageDataForTable = () => {
        if (selectedVersion === 'all') {
            return accessibleStages.find(stage => stage.level === selectedLevel);
        } else {
            return accessibleStages.find(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    const stageDataForTable = getStageDataForTable();
    const shouldShowTable = accessibleStages.length > 0 && isSelectedLevelValid();

    const getApprovalTypeDisplay = () => {
        return approvalType === 'arrear' && 'Arrear';
    };

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        hasAnyAccess ? (
                            <div className="bloc-tabs-with-white-bg justify-between">
                                {accessibleStages.length > 0 ? (
                                    <div className="field-cont-div">
                                        {accessibleStages.map((stage, index) => {
                                            const isActiveTab = selectedLevel === stage.level && parseInt(selectedVersion) === stage.version;

                                            return (
                                                <button
                                                    key={`${stage.version}-${stage.level}-${index}`}
                                                    style={{
                                                        cursor: 'help',
                                                        position: 'relative',
                                                        // borderLeft: `4px solid ${getApprovalTypeColor()}`
                                                    }}
                                                    className={
                                                        `bloc-tabs-with-white-bg-div
                                                         ${isActiveTab
                                                            ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                            : "dashboardcomponent-tabs font-weight400 font-size-subheading white-tab"}`
                                                    }
                                                    title={`${getApprovalTypeDisplay()} - Stage for ${stage.permissions} (Version ${stage.version} ${!stage.is_active ? '(Old Flow)' : ''})`}
                                                    onClick={() => {
                                                        setSelectedLevel(stage.level);
                                                        if (selectedVersion === 'all') {
                                                            setSelectedVersion(stage.version.toString());
                                                        }
                                                    }}
                                                >
                                                    {getApprovalTypeDisplay()} {stage.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stage.level}
                                                    {stage.pending_requests_count > 0 && (
                                                        <span
                                                            style={{
                                                                position: 'absolute',
                                                                top: '0px',
                                                                right: '-5px',
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                width: '13px',
                                                                height: '13px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                            }}
                                                            title={`${stage.pending_requests_count} pending requests`}
                                                        >
                                                            {stage.pending_requests_count > 99 ? '99+' : stage.pending_requests_count}
                                                        </span>
                                                    )}
                                                    <br />
                                                    <small className="text-gray-600">
                                                        {stage.employee
                                                            ? `Employee: ${stage.employee_name || stage.employee}`
                                                            : stage.role === "ReportingHead"
                                                                ? `Role: Reporting Head`
                                                                : stage.role
                                                                    ? `Role: ${stage.role}`
                                                                    : "Role/Dept not assigned"}
                                                        {selectedVersion === 'all' && ` • v${stage.version}`}
                                                        {!stage.is_active ? ' (Old)' : ' (Current)'}
                                                    </small>
                                                </button>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="bloc-tabs-with-white-bg justify-center">
                                        No accessible stages found for selected version
                                    </div>
                                )}

                                <div className="btn-cont">
                                    <hr className="field-cont-hr" />
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <select
                                            className="attendance-input-field width-20vw date-field"
                                            value={selectedVersion}
                                            onChange={(e) => {
                                                const newVersion = e.target.value;
                                                setSelectedVersion(newVersion);

                                                if (newVersion === 'all') {
                                                    const stageExists = accessibleStages.some(stage => stage.level === selectedLevel);
                                                    if (!stageExists && accessibleStages.length > 0) {
                                                        setSelectedLevel(accessibleStages[0].level);
                                                    }
                                                } else {
                                                    const thisVersionStages = accessibleStages.filter(stage =>
                                                        stage.version === parseInt(newVersion)
                                                    );

                                                    if (thisVersionStages.length > 0) {
                                                        const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                                                        if (!stageExists) {
                                                            setSelectedLevel(thisVersionStages[0].level);
                                                        }
                                                    }
                                                }
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option value="all">All Versions</option>
                                            {allVersions.map(version => {
                                                const format = dynamicApprovalFormats.find(f => f.version === version.version);
                                                const totalPending = format?.total_pending_requests_count || 0;
                                                return (
                                                    <option key={version.version} value={version.version}>
                                                        Version {version.version} {version.is_active ? '(Current)' : '(Old)'}
                                                        {totalPending > 0 && (
                                                            <span style={{
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                padding: '2px 6px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                marginLeft: '8px'
                                                            }}>
                                                                {totalPending > 99 ? '[99+ pending]' : `[${totalPending} pending]`}
                                                            </span>
                                                        )}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                        {pendingInVersion > 0 && (
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    right: '-5px',
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: '13px',
                                                    height: '13px',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                }}
                                                title={`${pendingInVersion} pending requests`}
                                            >
                                                {pendingInVersion > 99 ? '99+' : pendingInVersion}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For {getApprovalTypeDisplay()} Request Management
                            </div>
                        )
                }

                <div className="content-tabs-without-margin">
                    {shouldShowTable && stageDataForTable && (
                        <DynamicArrearApprovalTable
                            level={selectedLevel}
                            version={selectedVersion === 'all' ? stageDataForTable.version : parseInt(selectedVersion)}
                            formatData={dynamicApprovalFormats}
                            getApprovalStages={getArrearApprovalStages}
                            formatFor={formatFor}
                        />
                    )}
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

// General for all stages
const DynamicApprovalAllFormatStages = ({ approvalType = 'compensatory' }) => {
    const location = useLocation();

    const [selectedLevel, setSelectedLevel] = useState(0);
    const [selectedVersion, setSelectedVersion] = useState(1);
    const employee = sessionStorage.getItem('emp_code')
    const role = sessionStorage.getItem('role')
    const isreportinghead = sessionStorage.getItem('is_rh')
    const toggle_company = sessionStorage.getItem('company_id')

    const [dynamicApprovalFormats, setDynamicApprovalFormats] = useState([]);
    const [pendingInVersion, setPendingInVersion] = useState(0);
    const [buffer, setBuffering] = useState(false);

    const [allVersions, setAllVersions] = useState([]);
    const [accessibleStages, setAccessibleStages] = useState([]);
    const [hasAnyAccess, setHasAnyAccess] = useState(false);
    const [formatFor, setFormatFor] = useState(approvalType);

    const getDynamicApprovalStagesByFormat = async () => {
        setBuffering(true);
        try {
            const pro = await axios.get(
                `${BASE_URL}/wfm/dynamicapproval-versionedformatstages-bysubcompany-bytype-withpendingcount-withlegacy/${toggle_company}/${formatFor}/${employee}/`
            );
            const data = pro.data;
            setDynamicApprovalFormats(data);

            const totalPendingSum = data.reduce((sum, format) => {
                return sum + (format.total_pending_requests_count || 0);
            }, 0);

            setPendingInVersion(totalPendingSum);

            const currentActiveFlowFormat = data.find(format => format.is_active === true);

            if (selectedVersion === 1 && data.length > 0) {
                if (currentActiveFlowFormat) {
                    setSelectedVersion(currentActiveFlowFormat.version);

                    const accessibleStages = currentActiveFlowFormat.approval_stages?.filter(stage =>
                        (stage.role && stage.role === role) ||
                        (stage.employee && stage.employee === employee) ||
                        (stage.role === "ReportingHead" && isreportinghead)
                    ) || [];

                    if (accessibleStages.length > 0) {
                        const firstAccessibleStage = accessibleStages.sort((a, b) => a.level - b.level)[0];
                        setSelectedLevel(firstAccessibleStage.level);
                    }
                }
            }

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getDynamicApprovalStagesByFormat();
    }, [approvalType]);

    const getAllVersions = () => {
        return dynamicApprovalFormats.map(format => ({
            version: format.version,
            is_active: format.is_active,
            format_id: format.format_id,
        })).sort((a, b) => b.version - a.version);
    };

    const getFilteredStages = () => {
        if (!dynamicApprovalFormats.length) return [];

        let targetFormats = [];

        if (selectedVersion === 'all') {
            targetFormats = dynamicApprovalFormats;
        } else {
            const specificFormat = dynamicApprovalFormats.find(format => format.version === parseInt(selectedVersion));
            if (specificFormat) {
                targetFormats = [specificFormat];
            }
        }

        let accessibleStages = [];
        targetFormats.forEach(format => {
            const stagesForThisFormat = format.approval_stages?.filter(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            ) || [];

            const stagesWithFormatInfo = stagesForThisFormat.map(stage => ({
                ...stage,
                version: format.version,
                is_active: format.is_active,
            }));
            accessibleStages = [...accessibleStages, ...stagesWithFormatInfo];
        });

        return accessibleStages.sort((a, b) => a.level - b.level);
    };

    const hasAccessToAnyVersion = () => {
        return dynamicApprovalFormats.some(format =>
            format.approval_stages?.some(stage =>
                (stage.role && stage.role === role) ||
                (stage.employee && stage.employee === employee) ||
                (stage.role === "ReportingHead" && isreportinghead)
            )
        );
    };

    useEffect(() => {
        const newAllVersions = getAllVersions();
        const newAccessibleStages = getFilteredStages();
        const newHasAnyAccess = hasAccessToAnyVersion();

        setAllVersions(newAllVersions);
        setAccessibleStages(newAccessibleStages);
        setHasAnyAccess(newHasAnyAccess);
    }, [dynamicApprovalFormats, selectedVersion, role, employee, isreportinghead]);

    useEffect(() => {
        if (accessibleStages.length > 0 && selectedLevel === 0) {
            const firstStage = accessibleStages[0];
            setSelectedLevel(firstStage.level);
        }
    }, [accessibleStages, selectedVersion]);

    useEffect(() => {
        if (selectedVersion !== 'all') {
            const thisVersionStages = accessibleStages.filter(stage =>
                stage.version === parseInt(selectedVersion)
            );

            if (thisVersionStages.length > 0) {
                const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                if (!stageExists) {
                    setSelectedLevel(thisVersionStages[0].level);
                }
            }
        }
    }, [selectedVersion, accessibleStages]);

    const isSelectedLevelValid = () => {
        if (selectedVersion === 'all') {
            return accessibleStages.some(stage => stage.level === selectedLevel);
        } else {
            return accessibleStages.some(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    const getStageDataForTable = () => {
        if (selectedVersion === 'all') {
            return accessibleStages.find(stage => stage.level === selectedLevel);
        } else {
            return accessibleStages.find(stage =>
                stage.level === selectedLevel && stage.version === parseInt(selectedVersion)
            );
        }
    };

    const stageDataForTable = getStageDataForTable();
    const shouldShowTable = accessibleStages.length > 0 && isSelectedLevelValid();

    const getApprovalTypeDisplay = () => {
        const approvalTypeMap = {
            investment_declaration: "Investment Declaration",
            investment_proof: "Investment Proof",
            arrear: "Arrear",
            incentive: "Incentive",
            imprest: "Imprest",
            expense: "Expense",
            advance: "Advance",
            separation: "Separation",
            leave: "Leave",
            outduty: "Out Duty",
            compensatory: "Compensatory",
            empDetails: "Employee Details",
            bankdetails: "Bank Details",
            appraisal: "Appraisal",
        };

        return approvalTypeMap[approvalType] || "";
    };

    return (
        <>
            <div>
                {
                    buffer ? <div className="spinner"></div> :
                        hasAnyAccess ? (
                            <div className="bloc-tabs-with-white-bg justify-between">
                                {accessibleStages.length > 0 ? (
                                    <div className="field-cont-div">
                                        {accessibleStages.map((stage, index) => {
                                            const isActiveTab = selectedLevel === stage.level && parseInt(selectedVersion) === stage.version;

                                            return (
                                                <button
                                                    key={`${stage.version}-${stage.level}-${index}`}
                                                    style={{
                                                        cursor: 'help',
                                                        position: 'relative',
                                                        // borderLeft: `4px solid ${getApprovalTypeColor()}`
                                                    }}
                                                    className={
                                                        `bloc-tabs-with-white-bg-div
                                                         ${isActiveTab
                                                            ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                            : "dashboardcomponent-tabs font-weight400 font-size-subheading white-tab"}`
                                                    }
                                                    title={`${getApprovalTypeDisplay()} - Stage for ${stage.permissions} (Version ${stage.version} ${!stage.is_active ? '(Old Flow)' : ''})`}
                                                    onClick={() => {
                                                        setSelectedLevel(stage.level);
                                                        if (selectedVersion === 'all') {
                                                            setSelectedVersion(stage.version.toString());
                                                        }
                                                    }}
                                                >
                                                    {getApprovalTypeDisplay()} {stage.permissions === 'Finalize' ? 'Finalize ' : 'Approval '}Stage {stage.level}
                                                    {stage.pending_requests_count > 0 && (
                                                        <span
                                                            style={{
                                                                position: 'absolute',
                                                                top: '0px',
                                                                right: '-5px',
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                width: '13px',
                                                                height: '13px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                            }}
                                                            title={`${stage.pending_requests_count} pending requests`}
                                                        >
                                                            {stage.pending_requests_count > 99 ? '99+' : stage.pending_requests_count}
                                                        </span>
                                                    )}
                                                    <br />
                                                    <small className="text-gray-600">
                                                        {stage.employee
                                                            ? `Employee: ${stage.employee_name || stage.employee}`
                                                            : stage.role === "ReportingHead"
                                                                ? `Role: Reporting Head`
                                                                : stage.role
                                                                    ? `Role: ${stage.role}`
                                                                    : "Role/Dept not assigned"}
                                                        {selectedVersion === 'all' && ` • v${stage.version}`}
                                                        {!stage.is_active ? ' (Old)' : ' (Current)'}
                                                    </small>
                                                </button>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="bloc-tabs-with-white-bg justify-center">
                                        No accessible stages found for selected version
                                    </div>
                                )}

                                <div className="btn-cont">
                                    <hr className="field-cont-hr" />
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <select
                                            className="attendance-input-field width-20vw date-field"
                                            value={selectedVersion}
                                            onChange={(e) => {
                                                const newVersion = e.target.value;
                                                setSelectedVersion(newVersion);

                                                if (newVersion === 'all') {
                                                    const stageExists = accessibleStages.some(stage => stage.level === selectedLevel);
                                                    if (!stageExists && accessibleStages.length > 0) {
                                                        setSelectedLevel(accessibleStages[0].level);
                                                    }
                                                } else {
                                                    const thisVersionStages = accessibleStages.filter(stage =>
                                                        stage.version === parseInt(newVersion)
                                                    );

                                                    if (thisVersionStages.length > 0) {
                                                        const stageExists = thisVersionStages.some(stage => stage.level === selectedLevel);
                                                        if (!stageExists) {
                                                            setSelectedLevel(thisVersionStages[0].level);
                                                        }
                                                    }
                                                }
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option value="all">All Versions</option>
                                            {allVersions.map(version => {
                                                const format = dynamicApprovalFormats.find(f => f.version === version.version);
                                                const totalPending = format?.total_pending_requests_count || 0;
                                                return (
                                                    <option key={version.version} value={version.version}>
                                                        Version {version.version} {version.is_active ? '(Current)' : '(Old)'}
                                                        {totalPending > 0 && (
                                                            <span style={{
                                                                backgroundColor: 'red',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                padding: '2px 6px',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                marginLeft: '8px'
                                                            }}>
                                                                {totalPending > 99 ? '[99+ pending]' : `[${totalPending} pending]`}
                                                            </span>
                                                        )}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                        {pendingInVersion > 0 && (
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    right: '-5px',
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: '13px',
                                                    height: '13px',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                }}
                                                title={`${pendingInVersion} pending requests`}
                                            >
                                                {pendingInVersion > 99 ? '99+' : pendingInVersion}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="bloc-tabs-with-white-bg justify-center">
                                Not Authorized For {getApprovalTypeDisplay()} Request Management
                            </div>
                        )
                }

                <div className="content-tabs-without-margin">
                    {shouldShowTable && stageDataForTable && (
                        <>

                            {approvalType === "bankdetails" &&
                                <DynamicBankDetailsChangeApprovalTable
                                    level={selectedLevel}
                                    version={selectedVersion === 'all' ? stageDataForTable.version : parseInt(selectedVersion)}
                                    formatData={dynamicApprovalFormats}
                                    getApprovalStages={getDynamicApprovalStagesByFormat}
                                    formatFor={formatFor}
                                />
                            }
                            {approvalType === "arrear" &&
                                <DynamicArrearApprovalTable
                                    level={selectedLevel}
                                    version={selectedVersion === 'all' ? stageDataForTable.version : parseInt(selectedVersion)}
                                    formatData={dynamicApprovalFormats}
                                    getApprovalStages={getDynamicApprovalStagesByFormat}
                                    formatFor={formatFor}
                                />
                            }
                            {approvalType === "compensatory" &&
                                <DynamicCompensatoryApprovalTable
                                    level={selectedLevel}
                                    version={selectedVersion === 'all' ? stageDataForTable.version : parseInt(selectedVersion)}
                                    formatData={dynamicApprovalFormats}
                                    getApprovalStages={getDynamicApprovalStagesByFormat}
                                    formatFor={formatFor}
                                />
                            }
                        </>
                    )}
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};


export {
    DynamicRequestsManagementTab,
    DynamicLeaveApprovalStages,
    DynamicOutdutyApprovalStages,
    DynamicCompOffApprovalStages,
    DynamicImprestApprovalStages,
    DynamicExpenseBillingApprovalStages,
    DynamicAdvanceApprovalStages,
    DynamicSeprationApprovalStages,
    DynamicEmpDetailsChangeApprovalStages,
    DynamicBankDetailsChangeApprovalStages,
    DynamicInvestmentApprovalStages,
    DynamicArrearApprovalStages,

    DynamicApprovalAllFormatStages
}
